import { useEffect, useState } from "react";
import Button from "../../components/custom/input/button/Button";
import Modal from "../../components/custom/modal/Modal";
import { usePusher } from "../../context/PusherContext";
import { getRandomNumber } from "../utils/commonUtils";
import HNotification from "../../components/custom/notification/HNotification";

export default function AuthorizeButtonForUnipileAuth(props) {
  const { doAuthorization, authorizationSuccess, setRightServiceObj, authorizeButtonName } = props;
  const [unipileAuthModalOpen, setUnipileAuthModalOpen] = useState(false);
  const [authorizeButtonLoading, setAuthorizeButtonLoading] = useState(false);
  const [unipileAuthUrl, setUnipileAuthUrl] = useState();

  const { connect, unSubscribe, subscribe } = usePusher();

  const handleUnipileAuthModalOpen = async () => {
    setAuthorizeButtonLoading(true);
    try {
      const connectionSuccess = await connect(false, true);
      if (!connectionSuccess) throw new Error("Failed to connect to Pusher");
      await subscribe(
        "ACCOUNT_STATUS_UPDATE",
        (res) => {
          if (res?.data) {
            let accountCreationUpdateDataJson = JSON.parse(res?.data);
            if (accountCreationUpdateDataJson?.status) {
              setRightServiceObj((prev) => ({
                ...prev,
                ...accountCreationUpdateDataJson?.data,
              }));
              authorizationSuccess(getRandomNumber(5));
            }
          }
        },
        false,
        true
      );
      const response = await doAuthorization();
      if (!response) throw new Error("Something went wrong during authorization process!");
      setUnipileAuthUrl(response);
      setUnipileAuthModalOpen(true);
    } catch (e) {
      HNotification.notify({type: "error", message: "Error", description: e.message});
    } finally {
      setAuthorizeButtonLoading(false);
    }
  };

  const closeUnipileAuthModal = () => {
    setUnipileAuthUrl();
    setUnipileAuthModalOpen(false);
  };

  useEffect(() => {
    return () => {
      unSubscribe("ACCOUNT_STATUS_UPDATE", "AuthorizeButtonForUnipileAuth::useEffect::62");
    };
  }, []);

  return (
    <>
      <Modal
        open={unipileAuthModalOpen}
        modalContentClassName="d-grid gap-5"
        alignButton="center"
        modalCloseIcon={true}
        doOnClose={closeUnipileAuthModal}
      >
        {unipileAuthUrl ? (
          <iframe
            title="Authorize account"
            id="uniframe"
            src={unipileAuthUrl}
            style={{ border: "none", minHeight: "6in", height: "100%", width: "100%" }}
          />
        ) : null}
      </Modal>
      <Button buttonClassName="auth-btn w-50" loading={authorizeButtonLoading} size="xl" onClick={handleUnipileAuthModalOpen}>
        {authorizeButtonName || "Authorize"}
      </Button>
    </>
  );
}
